// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%27140%27 height=%27140%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.8%27 numOctaves=%273%27/%3E%3C/filter%3E%3Crect width=%27140%27 height=%27140%27 filter=%27url%28%23n%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------
   Reset + base
------------------------------------------------------------------- */

*,
*::before,
*::after { box-sizing: border-box; }

* { margin: 0; }

html {
  -webkit-text-size-adjust: 100%;
  scroll-behavior: smooth;
  scroll-padding-top: calc(var(--nav-h) + 20px);
}

body {
  font-family: var(--font-sans);
  font-size: var(--step-0);
  line-height: 1.65;
  color: var(--text);
  background: var(--bg);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  overflow-x: hidden;
  min-height: 100vh;
}

/* Backdrop: a flat ground with a drafting grid and a little film grain.
   No coloured aurora — the page should read as paper and ink, not as a
   screensaver. */
body::before {
  content: "";
  position: fixed;
  inset: 0;
  z-index: -2;
  pointer-events: none;
  background-image:
    linear-gradient(to right, var(--grid-line) 1px, transparent 1px),
    linear-gradient(to bottom, var(--grid-line) 1px, transparent 1px);
  background-size: 96px 96px;
  background-position: center top;
  mask-image: radial-gradient(ellipse 120% 90% at 50% 0%, #000 15%, transparent 75%);
  -webkit-mask-image: radial-gradient(ellipse 120% 90% at 50% 0%, #000 15%, transparent 75%);
}

/* Grain, as a single small tile the compositor can cache. */
body::after {
  content: "";
  position: fixed;
  inset: 0;
  z-index: -1;
  pointer-events: none;
  opacity: var(--grain-opacity);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

:root {
  --grid-line: rgba(255, 255, 255, 0.032);
  --grain-opacity: 0.035;
}
[data-theme="light"] {
  --grid-line: rgba(23, 21, 15, 0.05);
  --grain-opacity: 0.022;
}

img, svg, video, canvas { display: block; max-width: 100%; }
img { height: auto; }

h1, h2, h3, h4 {
  font-weight: 700;
  line-height: 1.08;
  letter-spacing: -0.028em;
  text-wrap: balance;
}

p { text-wrap: pretty; }

a {
  color: inherit;
  text-decoration: none;
  transition: color 0.22s var(--ease);
}

button, input, textarea, select {
  font: inherit;
  color: inherit;
}

button { background: none; border: 0; cursor: pointer; }

ul { list-style: none; padding: 0; }

::selection {
  background: var(--accent);
  color: var(--accent-ink);
}

:focus-visible {
  outline: 2px solid var(--accent);
  outline-offset: 3px;
  border-radius: 4px;
}

/* Scrollbar */
::-webkit-scrollbar { width: 11px; height: 11px; }
::-webkit-scrollbar-track { background: transparent; }
::-webkit-scrollbar-thumb {
  background: var(--line-strong);
  border-radius: 99px;
  border: 3px solid transparent;
  background-clip: content-box;
}
::-webkit-scrollbar-thumb:hover { background-clip: content-box; background-color: var(--accent); }

.skip-link {
  position: absolute;
  left: 50%;
  top: -100px;
  transform: translateX(-50%);
  z-index: 999;
  padding: 0.7rem 1.2rem;
  background: var(--accent);
  color: var(--accent-ink);
  border-radius: var(--r-pill);
  font-weight: 600;
  transition: top 0.2s var(--ease);
}
.skip-link:focus-visible { top: 12px; }

.sr-only {
  position: absolute;
  width: 1px; height: 1px;
  padding: 0; margin: -1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
  border: 0;
}

/* Anyone who asks for calm gets calm. */
@media (prefers-reduced-motion: reduce) {
  html { scroll-behavior: auto; }
  *, *::before, *::after {
    animation-duration: 0.001ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.001ms !important;
    scroll-behavior: auto !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/base.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE;;WAEW,sBAAsB,EAAE;;AAEnC,IAAI,SAAS,EAAE;;AAEf;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,mCAAmC;EACnC,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;iBAEiB;AACjB;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB;;qEAEmE;EACnE,0BAA0B;EAC1B,+BAA+B;EAC/B,kFAAkF;EAClF,0FAA0F;AAC5F;;AAEA,4DAA4D;AAC5D;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,6BAA6B;EAC7B,yDAA4R;AAC9R;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA,0BAA0B,cAAc,EAAE,eAAe,EAAE;AAC3D,MAAM,YAAY,EAAE;;AAEpB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,IAAI,iBAAiB,EAAE;;AAEvB;EACE,cAAc;EACd,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA,SAAS,gBAAgB,EAAE,SAAS,EAAE,eAAe,EAAE;;AAEvD,KAAK,gBAAgB,EAAE,UAAU,EAAE;;AAEnC;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,cAAc;AACd,sBAAsB,WAAW,EAAE,YAAY,EAAE;AACjD,4BAA4B,uBAAuB,EAAE;AACrD;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA,kCAAkC,4BAA4B,EAAE,+BAA+B,EAAE;;AAEjG;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,gCAAgC;AAClC;AACA,2BAA2B,SAAS,EAAE;;AAEtC;EACE,kBAAkB;EAClB,UAAU,EAAE,WAAW;EACvB,UAAU,EAAE,YAAY;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA,wCAAwC;AACxC;EACE,OAAO,qBAAqB,EAAE;EAC9B;IACE,sCAAsC;IACtC,uCAAuC;IACvC,uCAAuC;IACvC,gCAAgC;EAClC;AACF","sourcesContent":["/* ------------------------------------------------------------------\n   Reset + base\n------------------------------------------------------------------- */\n\n*,\n*::before,\n*::after { box-sizing: border-box; }\n\n* { margin: 0; }\n\nhtml {\n  -webkit-text-size-adjust: 100%;\n  scroll-behavior: smooth;\n  scroll-padding-top: calc(var(--nav-h) + 20px);\n}\n\nbody {\n  font-family: var(--font-sans);\n  font-size: var(--step-0);\n  line-height: 1.65;\n  color: var(--text);\n  background: var(--bg);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  text-rendering: optimizeLegibility;\n  overflow-x: hidden;\n  min-height: 100vh;\n}\n\n/* Backdrop: a flat ground with a drafting grid and a little film grain.\n   No coloured aurora — the page should read as paper and ink, not as a\n   screensaver. */\nbody::before {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  z-index: -2;\n  pointer-events: none;\n  background-image:\n    linear-gradient(to right, var(--grid-line) 1px, transparent 1px),\n    linear-gradient(to bottom, var(--grid-line) 1px, transparent 1px);\n  background-size: 96px 96px;\n  background-position: center top;\n  mask-image: radial-gradient(ellipse 120% 90% at 50% 0%, #000 15%, transparent 75%);\n  -webkit-mask-image: radial-gradient(ellipse 120% 90% at 50% 0%, #000 15%, transparent 75%);\n}\n\n/* Grain, as a single small tile the compositor can cache. */\nbody::after {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  z-index: -1;\n  pointer-events: none;\n  opacity: var(--grain-opacity);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='140' height='140'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='3'/%3E%3C/filter%3E%3Crect width='140' height='140' filter='url(%23n)'/%3E%3C/svg%3E\");\n}\n\n:root {\n  --grid-line: rgba(255, 255, 255, 0.032);\n  --grain-opacity: 0.035;\n}\n[data-theme=\"light\"] {\n  --grid-line: rgba(23, 21, 15, 0.05);\n  --grain-opacity: 0.022;\n}\n\nimg, svg, video, canvas { display: block; max-width: 100%; }\nimg { height: auto; }\n\nh1, h2, h3, h4 {\n  font-weight: 700;\n  line-height: 1.08;\n  letter-spacing: -0.028em;\n  text-wrap: balance;\n}\n\np { text-wrap: pretty; }\n\na {\n  color: inherit;\n  text-decoration: none;\n  transition: color 0.22s var(--ease);\n}\n\nbutton, input, textarea, select {\n  font: inherit;\n  color: inherit;\n}\n\nbutton { background: none; border: 0; cursor: pointer; }\n\nul { list-style: none; padding: 0; }\n\n::selection {\n  background: var(--accent);\n  color: var(--accent-ink);\n}\n\n:focus-visible {\n  outline: 2px solid var(--accent);\n  outline-offset: 3px;\n  border-radius: 4px;\n}\n\n/* Scrollbar */\n::-webkit-scrollbar { width: 11px; height: 11px; }\n::-webkit-scrollbar-track { background: transparent; }\n::-webkit-scrollbar-thumb {\n  background: var(--line-strong);\n  border-radius: 99px;\n  border: 3px solid transparent;\n  background-clip: content-box;\n}\n::-webkit-scrollbar-thumb:hover { background-clip: content-box; background-color: var(--accent); }\n\n.skip-link {\n  position: absolute;\n  left: 50%;\n  top: -100px;\n  transform: translateX(-50%);\n  z-index: 999;\n  padding: 0.7rem 1.2rem;\n  background: var(--accent);\n  color: var(--accent-ink);\n  border-radius: var(--r-pill);\n  font-weight: 600;\n  transition: top 0.2s var(--ease);\n}\n.skip-link:focus-visible { top: 12px; }\n\n.sr-only {\n  position: absolute;\n  width: 1px; height: 1px;\n  padding: 0; margin: -1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n/* Anyone who asks for calm gets calm. */\n@media (prefers-reduced-motion: reduce) {\n  html { scroll-behavior: auto; }\n  *, *::before, *::after {\n    animation-duration: 0.001ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.001ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
